import { mount } from '../../../js/dom-lifecycle';
import { Chart } from '../charts-bundle';

mount('script[data-mail-stats]', function () {
    const { chartData, labels } = JSON.parse(this.textContent);
    const canvas = document.getElementById('mailStatsChart');
    if (!canvas) return;

    new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: {
            labels: chartData.dates,
            datasets: [
                { label: labels.sent, data: chartData.sent, borderColor: '#007bff', backgroundColor: '#007bff', fill: false, tension: 0.1 },
                { label: labels.delivered, data: chartData.delivered, borderColor: '#28a745', backgroundColor: '#28a745', fill: false, tension: 0.1 },
                { label: labels.notDelivered, data: chartData.not_delivered, borderColor: '#dc3545', backgroundColor: '#dc3545', fill: false, tension: 0.1 },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 2.5,
            plugins: { legend: { position: 'bottom' } },
            scales: {
                y: {
                    beginAtZero: true,
                    min: 0,
                    suggestedMin: 10,
                    ticks: { stepSize: 1 },
                },
            },
        },
    });
});
